export const APP_NAME = "FolioWeather";

export default APP_NAME;
